module.exports = __webpack_public_path__ + "bcda35e95a5400994d01452b2e748336.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-32.png
// module id = 1716
// module chunks = 0